const ConvertNotifTypeToPersian = (notifType: string) => {
  switch (notifType) {
    case 'pest':
      return 'آفات';
    case 'water_requirement':
      return 'برنامه آبیاری';
    case 'fertilizer_recommendation':
      return 'توصیه کودی';
    case 'monitoring':
      return 'پایش ماهواره ای';
    case 'cultivation_management':
      return 'ثبت کشت';
    case 'staff':
      return 'کارکنان';
    case 'activity':
      return 'فعالیت';
    case 'warehouse':
      return 'انبار';
    case 'account':
      return 'حساب کاربری';
    case 'farm_management':
      return 'ثبت مزرعه';
    case 'weather':
      return 'هواشناسی';
    case 'store':
      return 'فروشگاه';
    case 'hojre':
      return 'حجره';
    case 'discounts':
      return 'تخفیف ها';
    case 'points':
      return 'امتیاز ها';
    case 'general':
      return 'عمومی';
    case 'advertisement':
      return 'تبلیغات';
    case 'expired_plan':
      return 'منقضی شدن طرح مزرعه';
    case 'access   ':
      return 'دسترسی';
    default:
      return '';
  }
};
export default ConvertNotifTypeToPersian;